/* eslint-disable */
export default {
  toolTip: '使用 {crmName} 檢視',
} as const;

// @key: @#@"toolTip"@#@ @source: @#@"View in {crmName}"@#@
